import { BlockError } from '@/blocks.04-project/block-error/block-error';
import { LazyInit } from '@/blocks.04-project/lazy-init/lazy-init';
import toNumber from 'lodash-es/toNumber';

/***
 * Класс для копирования текста из элемента
 * @example
 * Аттрибуты:
 * data-iv-copy {boolean, default = false} - аттрибут для инициализации
 * data-clear-time {number, default = 1000} - время в ms. через которе скроется тултип
 * data-copy-text {string, default = textContent} - текст для копирования. По умолчанию берёт textContent у блока
 * data-bs-... - аттрибуты настраиваемые через бутстрап
*/
class Copy {
  /***
   * Конструктор класса
   * @param elem {HTMLElement} DOM элемент с аттрибутом data-iv-copy
   * @param force {Boolean} принудительно инициализирование
   */
  constructor(elem, force) {
    this.BlockError = new BlockError({ blockName: 'Copy', destroy: this.destroy });

    if (!elem) return this.BlockError.error('Отсутствует elem');
    this.block = elem;
    this.block.Copy = this;
    this.block.AsyncCopy = new Promise((resolve) => {
      this.promiseResolve = resolve;
    }).then((ins) => ins);

    this.LazyInit = new LazyInit({ ins: this, callback: this.init, addClass: 'copy_inited' });
    this.LazyInit.init();
    if (force) this.LazyInit.earlyInit();
  }

  init = () => {
    this.getOptions();

    this.Tooltip = new window.Block.Tooltip(this.block, { trigger: 'manual' });
    this.tooltipIns = this.Tooltip?.tooltip;
    if (!this.tooltipIns) return this.BlockError.error('Ошибка инициализации тултипа');

    this.block.addEventListener('click', this.copy);
    this.block.addEventListener('keydown', this.onKeyDown);

    this.promiseResolve(this);
    this.block.AsyncCopy = this;
  };

  onKeyDown = ({ key }) => {
    if (key === 'Enter') this.copy();
  };

  copy = async () => {
    try {
      await navigator.clipboard.writeText(this.options.copyText);
      if (this.timer) clearTimeout(this.timer);
      else this.tooltipIns.show();

      this.timer = setTimeout(() => {
        this.tooltipIns.hide();
        this.timer = null;
      }, this.options.clearTime);
    } catch {
      this.BlockError.errorMessage('Не удалось скопировать текст');
      window.alert('Не удалось скопировать текст');
    }
  };

  getOptions = () => {
    this.options = {
      clearTime: toNumber(this.block.dataset['clearTime']) || 1000,
      copyText: this.block.dataset['copyText'] || this.block.textContent,
    };
  };

  destroy = () => {
    if (this.Tooltip) this.Tooltip.destroy();
    if (this.block) {
      this.block.removeEventListener('click', this.copy);
      this.block.removeEventListener('keydown', this.onKeyDown);
      this.block.classList.remove('copy_inited');
      delete this.block.Copy;
      delete this.block.AsyncCopy;
    }
  };

  static init(container = document, force = false) {
    Array.from(container.querySelectorAll('[data-iv-copy]:not(.copy_inited)')).forEach((elem) => new Copy(elem, force));
  }
}

document.addEventListener('DOMContentLoaded', () => Copy.init());

// Экспорт;
window.Block.Copy = Copy;
